<div class="w-full h-full">
  <!-- Fallbacks / errors -->
  <div *ngIf="invalidReason" class="p-4 text-red-600 text-sm">{{ invalidReason }}</div>

<!--  <div *ngIf="safeHtml && !invalidReason" [innerHTML]="safeHtml" class="weblink-content"></div>-->
  <!-- Iframe viewer -->
  <iframe *ngIf="safeUrl && !invalidReason"
          [src]="safeUrl"
          class="w-full h-full border-0"
          referrerpolicy="no-referrer"
          loading="eager">
  </iframe>

  <!-- Note about embedding restrictions -->
  <div *ngIf="!invalidReason && !safeUrl" class="p-4 text-gray-600 text-sm">
    Unable to display the page. Some websites block embedding in iframes.
    <span *ngIf="url">You can open it in a new tab: <a class="text-purple-700 underline" [href]="url" target="_blank" rel="noopener">{{ url }}</a></span>
  </div>
</div>
